export default "__VITE_ASSET__CKWQDRTU__"